<script setup>
import {computed} from 'vue'
import {useComponentsStore} from '@/stores/components'
import {useModalsStore} from '@/stores/modals'
import {useItemDataStore} from '@/stores/itemData'
import {useRoute, useRouter} from "vue-router"

const route = useRoute()
const router = useRouter()

// Pinia Stores
const componentsStore = useComponentsStore()
const modalsStore = useModalsStore()
const itemDataStore = useItemDataStore()

// --- Computed ---

const tableName = computed(() => route.params.component)

const component = computed(() => {
    return componentsStore.items.find(o => o.tableName === tableName.value)
})

const isForm = computed(() => component.value?.navigationGroup === 'Forms')

const label = computed(() => isForm.value ? 'form' : 'content type')

// --- Methods ---

const deleteForm = () => {
    modalsStore.show({
        componentName: 'ConfirmModal',
        obj: {
            modalTitle: 'Are you absolutely sure?',
            modalBody: `
                <div class="alert alert-danger">
                    <strong>This action will result in loss of data.</strong>
                </div>
                <p>
                    This action <strong>cannot</strong> be undone. This will permanently delete the ${label.value}
                    <strong>${component.value.title}</strong> and all of its data.
                </p>
            `,
            confirmStr: component.value.title,
            onConfirm: () => {
                itemDataStore.delete({
                        tableName: 'modulecomponents',
                        id: component.value.id
                    })
                    .finally(() => {
                        router.push({name: 'dashboard'})
                    })
            }
        }
    })
}
</script>

<template>
    <div class="root">
        <div>
            <h5 class="list-group-item-heading">Delete this {{ label }}</h5>

            <p class="mb-0">
                Once you delete a {{ label }}, all data is deleted and there is no going back. Please
                be certain.
            </p>
        </div>

        <button class="btn btn-danger ms-2" type="button" @click="deleteForm">
            Delete this {{ label }}
        </button>
    </div>
</template>

<style scoped>
.root {
    display: flex;
    align-items: center;
    font-size: 14px;
}

.root > :first-child {
    flex: auto;
}
</style>